import tinycolor from 'tinycolor2';

const lighten = (color, amount = 10) => {
  if (!color) return console.warn('No color given');

  return tinycolor(color)
    .lighten(amount)
    .toHexString();
};

const darken = (color, amount = 10) => {
  if (!color) return console.warn('No color given');

  return tinycolor(color)
    .darken(amount)
    .toHexString();
};

const saturate = (color, amount = 10) => {
  if (!color) return console.warn('No color given');

  return tinycolor(color)
    .saturate(amount)
    .toHexString();
};

const desaturate = (color, amount = 10) => {
  if (!color) return console.warn('No color given');

  return tinycolor(color)
    .desaturate(amount)
    .toHexString();
};

const setAlpha = (color, amount = 0) => {
  if (!color) return console.warn('No color given');

  return tinycolor(color)
    .setAlpha(amount)
    .toRgbString();
};

const isDark = (color) => tinycolor(color).isDark();
const isLight = (color) => tinycolor(color).isDark();

const colors = {
  red: '#F44336',
  pink: '#EC407A',
  purple: '#C088DA',
  deepPurple: '#9575CD',
  indigo: '#5C6BC0',
  blue: '#42A5F5',
  lightBlue: '#4FC3F7',
  cyan: '#26C6DA',
  teal: '#26A69A',
  green: '#66BB6A',
  lightGreen: '#83DEAD',
  lime: '#D4E157',
  yellow: '#FFEB3B',
  amber: '#FFCA28',
  orange: '#FFA726',
  deepOrange: '#FF7043',
  brown: '#8D6E63',
  grey: '#9E9E9E',
  blueGrey: '#607D8B',
  darkBluegrey: '#37474F',
  lightGrey: '#ECEFF1',
  white: '#FFFFFF',
  transparent: 'rgba(0, 0, 0, 0)'
};

const brand = {
  primary: '#4B4DF1',
  secondary: colors.indigo,
  accent: '#E4517F'
};

const status = {
  danger: colors.red,
  warning: colors.amber,
  info: colors.blue,
  success: colors.lightGreen
};

const background = {
  primary: colors.lightGrey,
  inverted: colors.darkBluegrey,
  body: '#f5f8fd'
};

const typography = {
  primary: colors.darkBluegrey,
  inverted: colors.lightGrey,
  secondary: lighten(colors.darkBluegrey, 40),
  lighter: lighten(colors.darkBluegrey, 60)
};

const gradients = {
  brand: `linear-gradient(to bottom right, ${lighten(desaturate('#4B4DF1'))}, ${lighten(desaturate('#8B3CA9', 5), 15)}, ${lighten(desaturate('#D14274', 5), 10)})`,
  topBar: `linear-gradient(to bottom right, ${tinycolor('#3023AE').setAlpha(0.0125).toRgbString()}, ${tinycolor('#4A90E2').setAlpha(0.0125).toRgbString()})`,
  successButton: 'linear-gradient(to bottom right, #81E390, #8BC34A)'
};

const shadows = {
  primary: '0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10)',
  hover: '0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15)'
};

export default {
  ...colors,
  materialColors: colors,
  gradients,
  shadows,
  brand,
  status,
  typography,
  background,
  lighten,
  darken,
  saturate,
  desaturate,
  setAlpha,
  isDark,
  isLight
};
